<script setup>
import { computed } from 'vue';
import { platformNames } from '../format.js';

const props = defineProps({
  platform: { type: String, required: true },
  size: { type: Number, default: 18 },
});

const label = computed(() => platformNames[props.platform] ?? '未知平台');
const source = computed(() => `/platforms/${props.platform}.svg`);
</script>

<template>
  <span class="platform-logo" :style="{ '--platform-logo-size': `${size}px` }" :title="label">
    <img :src="source" :alt="`${label} Logo`" />
  </span>
</template>
